/* eslint-disable prefer-destructuring */
import { CloudCircle, ModelTraining, Sync } from "@mui/icons-material";
import {
	Box,
	Divider,
	Icon,
	IconButton,
	LinearProgress,
	Tooltip,
	Typography,
	Dialog,
	DialogContent,
	DialogActions
} from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { t } from "i18next";
import lod_ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { display } from "redux-react/reducers/snackBarReducer";
import ConfirmDialogButton from "components/Custom/Dialogs/ConfirmDialogButton";
import EditKnowledge from "../Columns/FaiqIntegration/Actions/EditKnowledge";
import EditSummary from "../Columns/FaiqIntegration/Actions/EditSummary";
import SplitKnowledge from "../Columns/FaiqIntegration/Actions/SplitKnowledge";
import MergeKnowledge from "../Columns/FaiqIntegration/Actions/MergeKnowledge";
import TextDetails from "../Columns/FaiqIntegration/TextDetails";
import styled from "@emotion/styled";
import FormAction from "redux-react/actions/formAction";
import KnowledgeActions from "redux-react/actions/knowledgeActions";
import SourceActions from "redux-react/actions/sourceActions";
import MDButton from "components/Basics/MDButton";
import { socket } from "redux-react/middleware/ws";
import { translate } from "helpers/i18n";
import FaiqActions from "redux-react/actions/faiqActions";

const SectionTitle = styled(Typography)(({ theme }) => ({
	fontSize: "1rem",
	color: theme.palette.text.primary,
	marginBottom: theme.spacing(1),
	marginTop: theme.spacing(2),
	fontWeight: theme.typography.fontWeightRegular
}));

const KnowledgeHeader = styled(Box)(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	padding: theme.spacing(1.5),
	backgroundColor: theme.palette.grey[50],
	border: `1px solid ${theme.palette.grey[300]}`,
	borderRadius: theme.shape.borderRadius,
	marginBottom: theme.spacing(1)
}));

const ScrollableContent = styled(Box)({
	overflowY: "auto",
	flex: 1
});

const KnowledgeContent = ({ asset, reloadAssets = () => {} }) => {
	const dispatch = useDispatch();

	const [source, setSource] = useState({});
	const [sources, setSources] = useState([]);

	const sourceCodes = asset?.faiq?.codes;

	const code = asset?.code;
	const faiq = asset?.faiq || {};
	/**
	 * Delete the source from FAIQ
	 */
	const deleteSource = () => {
		dispatch(
			SourceActions.deleteSourcesAsset(
				asset.code,
				() => {
					dispatch(
						display({
							type: "success",
							message: t("FAIQ.SUCCESS.sourceUnlearned", {
								page: source.file?.name || t("TEXT.unknown")
							})
						})
					);
					reloadAssets(null, asset.id);
				},
				() => {
					dispatch(
						display({
							type: "error",
							message: t("FAIQ.ERROR.sourceUnlearned", {
								page: source.file?.name || t("TEXT.unknown")
							})
						})
					);
				}
			)
		);
	};

	const convertAssetToSource = () => {
		if (lod_.isNil(code)) {
			return;
		}

		dispatch(
			SourceActions.convertAssetToSource(
				code,
				{},
				res => {
					reloadAssets(null, asset.id);
				},
				err => {}
			)
		);
	};

	const retryProcess = () => {
		const step = faiq.step;

		switch (step) {
			case "pipeline": {
				const steps = faiq.steps || [];
				dispatch(FaiqActions.startFAIQPipeline(faiq.codes, steps, () => {}));
				break;
			}
			default: {
				convertAssetToSource();
			}
		}
	};

	const updateSource = () => {
		if (lod_.isNil(code)) {
			return;
		}

		dispatch(
			SourceActions.updateSourceWithAssetContent(
				code,
				res => {
					reloadAssets(null, asset.id);
				},
				err => {}
			)
		);
	};

	const getContent = () => {
		if (!lod_.isObject(faiq) || lod_.isEmpty(faiq) || faiq?.state === "waiting") {
			/* When asset has no source linked */
			return (
				<MDButton
					variant="contained"
					color="info"
					startIcon={<ModelTraining />}
					sx={{ mt: 5 }}
					onClick={() => {
						convertAssetToSource();
					}}
				>
					{t("ASSETS.FAIQ.STATUS.train")}
				</MDButton>
			);
		} else if (faiq.state === "importing") {
			/* Importing */
			return (
				<MDBox>
					<MDBox display="flex" flexDirection="column" alignItems="center" sx={{ mt: 5 }}>
						<MDTypography variant="button" color="info">
							{t("ASSETS.FAIQ.STATUS.training")}
						</MDTypography>

						<MDBox
							style={{
								width: "100%",
								overflow: "hidden",
								borderRadius: "100px"
							}}
						>
							<LinearProgress color="info" />
						</MDBox>
					</MDBox>
				</MDBox>
			);
		} else if (faiq.state === "error") {
			/* Error */
			return (
				<MDBox display="flex" flexDirection="column" alignItems="center" sx={{ mt: 5 }}>
					<MDTypography variant="button" color="error">
						{translate(faiq.error)}
					</MDTypography>
					<MDButton
						variant="contained"
						color="error"
						sx={{ mt: 1 }}
						startIcon={<Sync />}
						onClick={() => {
							retryProcess();
						}}
					>
						{t("SETTINGS.retry")}
					</MDButton>
				</MDBox>
			);
		} else if (faiq.state === "outdated") {
			/* Outdated */
			return (
				<MDBox display="flex" flexDirection="column" alignItems="center" sx={{ mt: 5 }}>
					<MDButton
						variant="contained"
						color="warning"
						sx={{ mt: 1 }}
						startIcon={<Sync />}
						onClick={() => {
							updateSource();
						}}
					>
						{t("SETTINGS.upgrade")}
					</MDButton>
				</MDBox>
			);
		} else {
			return null;
		}
	};

	const reloadAssetsInformations = () => {
		if (!lod_.isNil(asset)) {
			reloadAssets(null, asset.id);
		}
	};

	useEffect(() => {
		if (!lod_.isNil(asset)) {
			setSources([]);
			setSource({});
			//
			dispatch(
				FormAction.getItemsFromCollection(
					"faiqSource",
					{
						query: {
							code: { $in: sourceCodes }
						},
						projection: {
							summary: 1,
							code: 1,
							"file.name": 1
						}
					},
					res => {
						setSources(res.items || []);
						const firstSource = res.items?.[0] || null;
						setSource(firstSource);
					},
					res => {
						setSources([]);
						setSource({});
					}
				)
			);
		}

		socket.on("assets_reload_table", reloadAssetsInformations);

		return () => {
			socket.off("assets_reload_table", reloadAssetsInformations);
		};
	}, [asset]);

	if (
		lod_.isNil(sources) ||
		lod_.isEmpty(sources) ||
		lod_.isEmpty(source) ||
		["error", "outdated", "importing"].includes(faiq.state)
	) {
		return (
			<MDBox
				ml={2}
				sx={{
					flex: 1,
					display: "flex",
					flexDirection: "column",
					height: "100%",

					whiteSpace: "pre-wrap"
				}}
			>
				{/* Header */}
				<KnowledgeHeader>
					<MDBox display="flex" flexDirection="row" alignItems="center">
						<MDTypography variant="body2">{t("ASSETS.FAIQ.trainingTitle")}</MDTypography>
					</MDBox>
				</KnowledgeHeader>
				{/* Description */}
				<MDTypography variant="body2" color="text" sx={{ mt: 1, p: 2 }}>
					{t("ASSETS.FAIQ.trainingDescription")}
				</MDTypography>
				{/* Content */}
				<MDBox display="flex" flexDirection="column" alignItems="center" gap={3}>
					<MDBox sx={{ mt: 15 }} />

					{getContent()}

					<MDBox
						style={{
							overflow: "hidden",
							borderRadius: "100px"
						}}
					>
						<LinearProgress color="info" />
					</MDBox>
				</MDBox>
			</MDBox>
		);
	}

	return (
		<MDBox
			ml={2}
			sx={{ flex: 1, display: "flex", flexDirection: "column", height: "100%", overflow: "auto" }}
		>
			<KnowledgeHeader>
				<MDBox display="flex" flexDirection="row" alignItems="center">
					<MDTypography variant="body2">{t("ASSETS.FAIQ.trainingDoneTitle")}</MDTypography>
				</MDBox>
				{/* Right side */}
				<MDBox display="flex" alignItems="center">
					<ConfirmDialogButton
						onConfirm={(e, values) => deleteSource()}
						component={
							<MDButton
								variant="contained"
								color="error"
								size="small"
								startIcon={<Icon>remove_circle_outline</Icon>}
							>
								{t("ASSETS.FAIQ.removeTraining")}
							</MDButton>
						}
						title={t("ASSETS.FAIQ.removeTraining")}
						content={t("FAIQ.ACTIONS.confirmUnlearnedToFaiq", {
							file: source.file?.name || t("TEXT.unknown")
						})}
					/>
				</MDBox>
			</KnowledgeHeader>

			<ScrollableContent>
				{/*  */}
				<Box>
					<MDBox display="flex" justifyContent="space-between" alignItems="center">
						<SectionTitle>{t("SOURCES.PIPELINE.summary")}</SectionTitle>
						<EditSummary source={source} reload={reloadAssetsInformations} />
					</MDBox>
					<TextDetails
						text={source?.summary || t("FAIQ.ERROR.noSummaryAvailable")}
						minHeight="10vh"
					/>
				</Box>
				{/*  */}
				<Box mb={2}>
					<KnowledgesDetails sourceCode={source.code} />
				</Box>
			</ScrollableContent>
		</MDBox>
	);
};

export default KnowledgeContent;

/**
 * Knowledges details component
 * @param {Object} props - Component props
 * @param {string} props.sourceCode - Source code to fetch knowledges
 * @return {JSX.Element} - Rendered component
 */
const KnowledgesDetails = ({ sourceCode }) => {
	const [knowledges, setKnowledges] = useState([]);
	const operationalKnowledges = knowledges.filter(knowledge => knowledge.edited === false);
	const dispatch = useDispatch();

	const getKnowledges = () => {
		dispatch(
			KnowledgeActions.getKnowledgesBySourceCode(sourceCode, res => {
				const result = res?.knowledges || [];
				setKnowledges(result);
			})
		);
	};

	useEffect(() => {
		getKnowledges();

		socket.on("knowledge_train_result", getKnowledges);

		return () => {
			socket.off("knowledge_train_result", getKnowledges);
		};
	}, [sourceCode]);

	return (
		<MDBox mb={10}>
			<MDBox display="flex" justifyContent="space-between" alignItems="center">
				<SectionTitle>{t("SOURCES.PIPELINE.knowledges")}</SectionTitle>
				<MDTypography variant="caption">
					{`(${operationalKnowledges.length}/${knowledges.length} ${t("TEXT.operational")})`}
				</MDTypography>
			</MDBox>
			{knowledges.map((knowledge, index) => {
				return (
					<SimpleKnowledgeContent
						key={index}
						knowledge={knowledge}
						knowledges={knowledges}
						reload={getKnowledges}
					/>
				);
			})}
		</MDBox>
	);
};

/**
 * Knowledge content component
 * @param {Object} props - Component props
 * @param {Object} props.knowledge - Knowledge object to display
 * @param {Array} props.knowledges - List of all knowledges
 * @param {Function} props.reload - Function to reload knowledges
 * @return {JSX.Element} - Rendered component
 */
const SimpleKnowledgeContent = ({ knowledge, knowledges, reload }) => {
	const dispatch = useDispatch();
	const [synchronizing, setSynchronizing] = useState(false);
	const [showEmbeddings, setShowEmbeddings] = useState(false);

	const contentEmbeddings = knowledge?.contentEmbeddings ?? knowledge?.embeddings ?? "";

	const trainKnowledge = uuid => {
		dispatch(KnowledgeActions.trainKnowledges([uuid], res => {}));
	};

	const deleteKnowledge = () => {
		dispatch(
			KnowledgeActions.deleteKnowledge(
				knowledge.uuid,
				() => {
					dispatch(
						display({
							type: "success",
							message: t("KNOWLEDGE.SUCCESS.delete")
						})
					);
					reload();
				},
				() => {
					dispatch(
						display({
							type: "error",
							message: t("KNOWLEDGE.ERROR.deleteKnowledge")
						})
					);
				}
			)
		);
	};

	useEffect(() => {
		setSynchronizing(false);
	}, [knowledge]);

	return (
		<MDBox mb={2} display="flex" flexDirection="column">
			<KnowledgeHeader>
				<MDBox display="flex" gap={1} alignItems="center">
					{knowledge.edited && (
						<Tooltip title={t("FAIQ.ACTIONS.knowledgeNotSynchro")} placement="top">
							<CloudCircle fontSize="small" color="error" />
						</Tooltip>
					)}
					{!knowledge.edited && (
						<Tooltip title={t("FAIQ.ACTIONS.knowledgeSynchro")} placement="top">
							<IconButton size="small" onClick={() => setShowEmbeddings(true)}>
								<CloudCircle fontSize="small" color="success" />
							</IconButton>
						</Tooltip>
					)}
					{/* Synch */}
					<Tooltip title={t("FAIQ.ACTIONS.startKnowledgeSynchro")} placement="top">
						<IconButton
							size="small"
							disabled={!knowledge.edited || synchronizing}
							onClick={() => {
								setSynchronizing(true);
								trainKnowledge(knowledge.uuid);
							}}
						>
							<Icon>sync</Icon>
						</IconButton>
					</Tooltip>
				</MDBox>
				<MDBox display="flex" gap={1} alignItems="center">
					{/* Edit */}
					<EditKnowledge knowledge={knowledge} reload={reload} />

					{/* Split */}
					<SplitKnowledge knowledge={knowledge} reload={reload} />

					{/* Fusion */}
					<MergeKnowledge knowledge={knowledge} knowledges={knowledges} reload={reload} />

					{/* Delete */}
					<ConfirmDialogButton
						onConfirm={(e, values) => deleteKnowledge()}
						component={
							<Tooltip title={t("SETTINGS.delete")} placement="top">
								<IconButton size="small">
									<Icon>delete</Icon>
								</IconButton>
							</Tooltip>
						}
						title={t("FAIQ.ACTIONS.deleteKnowledgeConfirmTitle")}
						content={t("FAIQ.ACTIONS.deleteKnowledgeConfirmDescription", {
							knowledge: `${knowledge.content.slice(0, 50)}...`
						})}
					/>
				</MDBox>
			</KnowledgeHeader>
			{/* Knowledge content */}
			<MDBox
				sx={{
					overflow: "auto"
				}}
			>
				<TextDetails text={knowledge.content || t("FAIQ.ACTIONS.noContent")} minHeight="20vh" />
			</MDBox>
			<Divider />

			{/* Embeddings Dialog */}
			<Dialog
				open={showEmbeddings}
				onClose={() => setShowEmbeddings(false)}
				maxWidth="md"
				fullWidth
			>
				<DialogContent>
					<MDBox sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", mt: 2 }}>
						{typeof contentEmbeddings === "string"
							? contentEmbeddings
							: JSON.stringify(contentEmbeddings, null, 2)}
					</MDBox>
				</DialogContent>
				<DialogActions>
					<MDButton onClick={() => setShowEmbeddings(false)} color="info">
						{t("SETTINGS.close")}
					</MDButton>
				</DialogActions>
			</Dialog>
		</MDBox>
	);
};
